export default function addPost(oldPosts, newPost) {
  if (newPost.replies?.length > 0) {
    return oldPosts.map((oldPost) =>
      oldPost.id === newPost.id ? newPost : oldPost,
    );
  } else {
    return [newPost, ...oldPosts];
  }
}
